import { render, staticRenderFns } from "./courseCenterInfo.vue?vue&type=template&id=17969334&scoped=true"
import script from "./courseCenterInfo.vue?vue&type=script&lang=js"
export * from "./courseCenterInfo.vue?vue&type=script&lang=js"
import style0 from "./courseCenterInfo.vue?vue&type=style&index=0&id=17969334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17969334",
  null
  
)

export default component.exports